import { createContext } from "react";

const PdfURLContext = createContext();

export default PdfURLContext;